import React from "react";
import PaymentsControl from "../../../../form/purchase/payments";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems, refresh, actionButtons} = props;
    return (hidden || []).indexOf("payment") === -1 &&
        <PaymentsControl
            availableProviders={props.availablePaymentProviders}
            operationitems={operationitems}
            refresh={refresh}
            {...props.getFieldProps("payments")}
            name="payments"
            value={props.getValue("payments")}
            label="Fizetési mód"
            rounding={props.rounding || 0}
            overpay={props.overpay || 0}
            cost={props.cost || 0}
            total={props.total || 0}
            saveChanges={props.setFieldValue}
            providerTheme={props.providerTheme}
        />;
}